<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import addedit from "./addedit";
import tlphaziryanitlar from "@/models/tlphaziryanitlar";
export default {
  mixins: [Api, Sabit, tlphaziryanitlar],
  page: {
    title: "Hazır Yanıtlar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    addedit,
  },
  data() {
    return {
      title: "Hazır Yanıtlar",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Sistem Yönetimi",
          href: "/",
        },
        {
          text: "Hazır Yanıtlar",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
    };
  },

  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "tlphaziryanitlar",
        Page: this.Page,
        Filter: "&Desc=",
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <button
                    type="button"
                    class="btn btn-primary btn-rounded mb-2 me-2"
                    v-b-modal.tlphaziryanitlar
                    @click="(DataUpdate = tlphaziryanitlarData), (AddEdit = 'Add')"
                  >
                    <i class="mdi mdi-plus me-1"></i>
                    Yeni Kayıt Ekle
                  </button>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Başlık</th>
                      <th>Metin</th> 
                      <th    class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          " >İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Baslik }}</th>
                      <td>{{ Data.Metin }}</td> 
                      <td>
                        <div
                          class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <b-button-group>
                            <b-button
                              v-b-tooltip.hover
                              title="Düzenle"
                              variant="success"
                              v-b-modal.tlphaziryanitlar
                              @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                              ><i class="far fa-edit"></i
                            ></b-button>
                            <b-button
                              variant="danger"
                              v-b-tooltip.hover
                              title="Sil"
                              @click="Delete('tlphaziryanitlar', Data.Id)"
                              ><i class="far fa-trash-alt"></i
                            ></b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
